import { PAGES, type PageId } from '../pages'

/**
 * Alt sekme çubuğu — yalnız mobilde görünür.
 *
 * Görünürlük kararı CSS'te (`display`), JS'te DEĞİL: bu bir yerleşim sorusu ve
 * `@media` ile çözülünce ekran döndürüldüğünde ya da pencere yeniden
 * boyutlandığında React'in haberi olması gerekmiyor. Üst şeritteki menü de aynı
 * şekilde mobilde gizleniyor; ikisi de `pages.ts`ten beslendiği için bir sayfa
 * eklendiğinde iki yerde birden çıkıyor.
 *
 * Çubuk `.app`in SON esnek çocuğu; `position: fixed` değil. Kabuk zaten ekran
 * yüksekliğinde ve içerik kendi kaplarında kaydığı için çubuk akışta yer
 * tutabiliyor. Kazancı: hiçbir sayfaya "altta çubuk kadar boşluk bırak" payı
 * eklemek gerekmiyor, z-index yarışı yok, klavye açılınca çubuk içeriğin
 * üstüne binmiyor.
 *
 * Rozet (açık emir sayısı vb.) BİLEREK yok: soket yalnız SEÇİLİ kontratın
 * emirlerini taşıyor, tüm tahtayı kapsayan bir sayaç elimizde değil. Rozet,
 * doğru verisiyle birlikte Faz 2'de `İşlem` sekmesine gelecek.
 */

interface Props {
  page: PageId
  onNavigate: (page: PageId) => void
}

export function TabBar({ page, onNavigate }: Props) {
  return (
    <nav className="tabbar" aria-label="Sayfalar">
      {PAGES.map((item) => {
        const aktif = page === item.id
        return (
          <button
            key={item.id}
            type="button"
            className={`tab-item${aktif ? ' active' : ''}`}
            aria-current={aktif ? 'page' : undefined}
            onClick={() => onNavigate(item.id)}
          >
            {/* İkon kendi kabında: seçili sekmenin hapı yalnız ikonun arkasına
                iniyor, etiketi kapsamıyor. */}
            <span className="tab-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22">
                {item.icon.map((d, i) => (
                  <path key={i} d={d} />
                ))}
              </svg>
            </span>
            <span className="tab-label">{item.short}</span>
          </button>
        )
      })}
    </nav>
  )
}
